import * as types from './actionTypes';
import { flattenObj } from '../../lib/utils';
import { postRequest } from '../../lib/apiUtils';
import { getOrganizations } from './RecipientAccountsActions';
import { RecipientTypes } from '../../lib/systemVariables';
import { clearRecipientSummaryCache } from '../../lib/recipientSummaryCache';

export function createApplication(recipient, application, bypass = false) {
    const recipientObj = {
        applicantType: recipient.applicantType,
        isIsraeli: recipient.isIsraeli,
        personTitleId: recipient.personTitleId,
        firstName: recipient.firstName,
        lastName: recipient.lastName,
        reportName: recipient.reportName,
        organization: recipient.organization,
        address: recipient.address,
        previousAddress: recipient.previousAddress,
        phoneNumber: recipient.phoneNumber,
        phoneType: recipient.phoneType,
        secondPhoneNumber: recipient.secondPhoneNumber,
        secondPhoneType: recipient.secondPhoneType,
        email: recipient.email,
        teudatZahut: recipient.teudatZehut,
        bankRoutingNumber: recipient.bankRoutingNumber,
        bankBranchNumber: recipient.bankBranchNumber,
        bankAccountNumber: recipient.bankAccountNumber,
        bankAccountHolder: recipient.bankAccountHolder,
        tags: recipient.tags,
        note: recipient.note,
        trustedPayeeId: recipient.trustedPayeeId,
        references: recipient.references,
        solicitors: recipient.solicitors,
        roshYeshivas: recipient.roshYeshivas,
        applicantPledges: recipient.applicantPledges,
    };
    if (recipient.id) recipientObj.id = recipient.id;

    return async dispatch => {
        dispatch({ type: types.START_CREATE_APPLICATION });
        let recipResponse;
        if (!recipient.id) {
            recipResponse = await postRequest('/recipients', recipientObj, {});
            if (!recipResponse.success) {
                dispatch({ type: types.CREATE_APPLICATION, response: recipResponse });
                return;
            } else {
                application.recipientId = recipResponse.data;
            }
        } else {
            application.recipientId = recipient.id;
        }

        const formData = new FormData();
        const flatObj = flattenObj(application);
        for (const prop in flatObj) formData.append(prop, flatObj[prop] !== null ? flatObj[prop] : '');
        application.attachments.map(attachment => formData.append('attachments', attachment));
        const url = bypass === true ? `/applications?bypassError=${bypass}` : '/applications';
        const response = await postRequest(url, formData, { 'Content-Type': 'multipart/form-data' }, {});
        if (response.success) clearRecipientSummaryCache(application.recipientId);
        dispatch({ type: types.CREATE_APPLICATION, response : { ...response, id: application.recipientId } });

        if(response.success && recipient.applicantType === RecipientTypes.Organization)
            dispatch(getOrganizations());
    }
}




// WEBPACK FOOTER //
// ./src/redux/actions/CreateApplicationActions.js